import React, { Component } from 'react';

export default class PaginationDots extends React.Component {
  constructor(props) {
    super(props);
    this.activeIndex = props.activeIndex;
  }

  activeClassName(i) {
    let activeClass = '';
    if (this.activeIndex == i) {
      activeClass = 'is-active';
    }
    return `pagination__dot ${activeClass}`;
  }

  render() {
    return (
      <ul className="pagination">
        <li className={this.activeClassName(0)}></li>
        <li className={this.activeClassName(1)}></li>
        <li className={this.activeClassName(2)}></li>
      </ul>
    );
  }
}
